import React from 'react'

const IcTransactionDefault = (props) => {
    return (
        <svg {...props} width="141" height="140" viewBox="0 0 141 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.1" cx="70.5" cy="70" r="70" fill="#B7B7B7"/>
        <path d="M48.6667 47.0334L37.1667 70V90C37.1667 91.7682 37.869 93.4638 39.1193 94.7141C40.3695 95.9643 42.0652 96.6667 43.8333 96.6667H97.1667C98.9348 96.6667 100.63 95.9643 101.881 94.7141C103.131 93.4638 103.833 91.7682 103.833 90V70L92.3333 47.0334C91.7814 45.9227 90.9306 44.9879 89.8765 44.3343C88.8224 43.6807 87.6069 43.334 86.3667 43.3334H54.6333C53.393 43.334 52.1775 43.6807 51.1235 44.3343C50.0694 44.9879 49.2186 45.9227 48.6667 47.0334Z" fill="#B7B7B7" stroke="#B7B7B7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M103.833 70H83.8333L77.1667 80H63.8333L57.1667 70H37.1667" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
}

export default IcTransactionDefault
